import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { filter, map, takeUntil, tap } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';

import { Profile } from '../../core/services/suggestions/suggestions.model';
import { loadSuggestedProfiles } from '../../core/services/suggestions/suggestions.actions';
import { selectSuggestedProfiles } from '../../core/services/suggestions/suggestions.reducer';
import {
  addContact,
  removeContact
} from '../../core/services/contacts/contacts.actions';
import { clearComments } from '../../shared/ui/post/data/store/actions';
import { loadProfileReferences, addReference } from './info/store/info.actions';
import { selectProfileReferences } from './info/store/info.reducer';
import { AuthService } from '../../core/services/auth.service';
import { ConvertIdService } from '../../core/services/convert-id.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit, OnDestroy {
  suggestedProfiles$: Observable<Profile[]>;
  referencesProfiles$: Observable<any[]>;
  userId$: Observable<string>;
  postId$: Observable<string>;
  public isMyProfile$: Observable<boolean>;

  private readonly _destroy$ = new Subject<void>();

  constructor(
    private activatedRoute: ActivatedRoute,
    private store: Store,
    private auth: AuthService
  ) {
    this.suggestedProfiles$ = this.store.pipe(
      select(selectSuggestedProfiles())
    );
  }

  ngOnInit(): void {
    this.auth.isFullyAuthorized$
      .pipe(
        tap((_) => this.loadData(_)),
        takeUntil(this._destroy$)
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.store.dispatch(clearComments());

    this._destroy$.next();
    this._destroy$.complete();
  }

  get profileId$() {
    return this.activatedRoute.params.pipe(map((_) => _.userId));
  }

  onProfileConnect(id: number) {
    this.store.dispatch(addContact({ id }));
  }

  onProfileDisconnect(id: number) {
    this.store.dispatch(removeContact({ id }));
  }

  addReference(reference, obj_id) {
    this.store.dispatch(addReference({ reference: { ...reference, obj_id } }));
  }

  private loadData(isNotGuest: boolean) {
    if (isNotGuest) {
      this.store.dispatch(loadSuggestedProfiles({ N: 5 }));
    }

    this.userId$ = this.activatedRoute.params.pipe(
      filter(
        (params) =>
          params.hasOwnProperty('userId') || params.hasOwnProperty('id')
      ),
      map((param) => param.userId || param.id),
      tap((profileId) => {
        if (isNotGuest) {
          // TODO: redo
          // why do we need to be authorized to fetch some profile references ?
          this.store.dispatch(loadProfileReferences({ profileId }));
        }
      })
    );
    this.referencesProfiles$ = this.store.pipe(
      select(selectProfileReferences())
    );
    this.postId$ = this.activatedRoute.params.pipe(
      // filter(params => params.hasOwnProperty('postId')),
      map((param) => param.postId)
    );
  }
}
